/* eslint-disable no-useless-return */
/* eslint-disable eqeqeq */
import _ from 'lodash'
import { soapPost } from '../../ajaxSoap'
import { bizTypeMap } from '../../bizTypeMapping'
import { userInfo, $notify } from '../../../global'
import { i18n } from '../../i18n'
import * as checkConstant from '@/api/biz/outbound/checkConstant';
// eslint-disable-next-line no-unused-vars
import { get, post } from '@/api/rest/ajax'
import { restUrls } from '@/api/rest/url'
import { customizeNotifyWithVoice, NOTIFY_TYPE_ENUM } from '@/api/utils/message.js'
import { MasterPropertyType } from '@/api/biz/bizEnum'
import route from '@/router.js'
import store from '@/store/store.js';

export const getPalletPrintLabelParam = async (params) => {
  let ret
  await soapPost(bizTypeMap.getPalletPrintLabelParam, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPlatformInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_004, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 轨迹查询
export const queryTrackExternally = async (params, callback) => {
  let ret
  await soapPost(bizTypeMap.queryTrackExternally, params, {noShowError: true, callback})
    .done(function (data) {
      ret = data
    })
  return ret
}

// 轨迹注册
export const registerTrackIfNeeded = async (params) => {
  let ret
  await soapPost(bizTypeMap.registerTrackIfNeeded, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const querySimpleEquipmentList = async (newcrete) => {
  let ret
  const { catalog, ...params } = newcrete
  console.log("🚀 ~ querySimpleEquipmentList ~ catalog:", catalog)
  await soapPost(bizTypeMap.querySimpleEquipmentList, params)
    .done(function (data) {
      ret = data
    })
  // 为空校验
  if (!ret || ret.length === 0) {
    return null
  }
  console.log("🚀 ~ querySimpleEquipmentList ~ ret:", ret)
  let resultList = ret

  if (catalog) {
    resultList = resultList.filter(item => catalog.includes(item.catalog))
  }
  console.log("🚀 ~ querySimpleEquipmentList ~ resultList:", resultList)
  // 类型匹配失败校验
  if (resultList.length === 0) {
    $notify.error(i18n.t('workbenchTypeMachFailed'))
    return
  }
  // 工作台号重复校验
  if (resultList.length > 1) {
    $notify.error(i18n.t('workbenchNumberDuplicate'))
    return
  }

  return resultList[0]
}

export const occupyPlatformNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_006, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const activatePlatForm = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_214, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const changePlatformNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_005, newcrete, { noParseJson: true, formatData:[newcrete.targetCode] })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getOrdersByContainerNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_100, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getContainerInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getContainerInfo, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getOrdersByContainerNoV2 = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_99, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 向打包机请求耗材
export const queryConsumerFromPackMachine = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryConsumerFromPackMachine, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const getOrdersByWallNo = async (params) => {
  let ret
  await soapPost(bizTypeMap.customer_101, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const checkInputIsBoxRuleCodeOrUniqueBoxCode = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_121, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getCheckedAndUncheckedListByOutBoundNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_122, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const addPallet = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.box_007, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const checkTheBoxIsFullPalletOrNot = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.box_008, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const changePalletForBox = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.box_009, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const toBFullPallet = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.box_010, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const checkPalletFullOrNot = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.box_011, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const switchPallet = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.switchPallet, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const checkAllPalletFullOrNot = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.checkAllPalletFullOrNot, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const queryTurnoverBox = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryTurnoverBox, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const showCheckContainerDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_119, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const scanGoodsInfoByCodeFour = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_007, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 商品序列号
export const getGoodsInfoBySerialNo = async (strSerialNo, goodsNoList) => {
  let goodsList = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    serial:strSerialNo,
    code:strSerialNo
  }
  await soapPost(bizTypeMap.master_003, query)
    .done(function (data) {
      goodsList = data
    })
  let baseInfoOfGoods = findGoodsInfo(goodsList, goodsNoList);
  return baseInfoOfGoods;
}

// 扫描二维码获取序列号
export const getGoodsInfoByQRCode = async (strSerialNo, goodsNoList) => {
  let goodsList = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    serial:strSerialNo,
    code:strSerialNo
  }
  await soapPost(bizTypeMap.master_030, query)
    .done(function (data) {
      goodsList = data
    })
  return goodsList;
}

// 通过唯一码获取商品信息
export const getGoodsInfoByUniqueCode = async (goodsNo, uniqueCode) => {
  let goodsList = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    goodsNo: goodsNo,
    serial:uniqueCode,
    code:uniqueCode
  }
  console.log('getGoodsInfoByUniqueCode query: '+ JSON.stringify(query))
  await soapPost(bizTypeMap.master_003, query)
    .done(function (data) {
      goodsList = data
    })
    console.log('getGoodsInfoByUniqueCode goodsList: '+ JSON.stringify(goodsList))
  return goodsList;
}

// 一次性拉取订单下整单各商品的批次应出件数配额
export const getOrderLotQuota = async (checkingOrder, lotQuotaMap) => {
  let outboundNo = checkingOrder.outboundNo
  if (lotQuotaMap?.outboundNo === outboundNo) return lotQuotaMap; // 已加载（含空对象）不再重复拉取
  let ret = {outboundNo};
  try{
    await soapPost(bizTypeMap.queryShipmentLotSummary, {outboundNo})
      .done(function (res) {
        let map = {}
        let lotArr = []
        if(res && Array.isArray(res.detailList)){
          res.detailList.forEach(item => {
            const lotAttrNo = !item.lotAttrNo || item.lotAttrNo === '-1' ? '' : item.lotAttrNo
            map[`${item.goodsNo}#${lotAttrNo}`] = Math.max(item.goodsQty, 0)
            if(lotAttrNo) lotArr.push(lotAttrNo)
          })
        }
        ret = { outboundNo,lotArr, ...map}
      })
  }catch(e){
    console.log(e)
  }
  return ret;
}

// 通过唯一码获取商品信息
export const checkUniqueIsRight = async (goodsNo, uniqueCode) => {
  let ret = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    goodsNo: goodsNo,
    serial:uniqueCode
  }
  console.log('checkUniqueIsRight query: '+ JSON.stringify(query))
  await soapPost(bizTypeMap.wms_check_master_029, query)
    .done(function (data) {
      ret = data
    })
    console.log('checkUniqueIsRight ret: '+ JSON.stringify(ret))
  return ret;
}

export const validateSerialNoUsed = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_012, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSystemId = async () => {
  // let systemId = await getOriginalSystemId();  //后台也只有一个common
  // if (systemId) {
  //   systemId = systemId.toUpperCase();
  // } else {
  //   systemId = checkConstant.SYSTEMID_COMMON;
  // }
  let systemId = checkConstant.SYSTEMID_COMMON;
  return systemId;
}

export const getOriginalSystemId = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getSystemId, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackageTag = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_015, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const addCheckResultForCustomerOrder = async (newcrete) => {
  let ret
  console.log('customer_200', newcrete)
  await soapPost(bizTypeMap.customer_200, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const calculateSoftWrapDimWeight = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.calculateSoftWrapDimWeight, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const insertPackageOperationDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.insertPackageOperationDetail, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getOrderRecheckStatus = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getOrderRecheckStatus, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackingListInfo = async (newcrete) => {
  let result
  await soapPost(bizTypeMap.queryPackingListInfo, newcrete)
    .done(function (data) {
      result = data
    })
  return result
}

export const addPackageMInfo = async (newcrete) => {
  let ret
  console.log('customer_217', newcrete)
  await soapPost(bizTypeMap.customer_217, newcrete, { noParseJson: false })
    .done(function (data) {
      ret = data
    })
  return ret
}

// 差异场景关容器(call单)前，让后端修改最后一个包裹号，入参按 customer_217(ObPackageM) 来
export const diffChangePackageNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.diffChangePackageNo, newcrete, { noParseJson: false })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const doPackageWeightCheck = async (newcrete, callback) => {
  let ret
  await soapPost(bizTypeMap.common_037, newcrete, { noParseJson: true, callback })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const updatePackageMInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.updatePackageMLogisticsAttributes, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const modifyPackageNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.modifyPackageNo, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackageCount = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_218, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const addB2BBoxCheckResultForCustomerOrder = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_219, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}


export const querySupplierList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.querySupplierList, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 查询交接单集合
export const queryPrintInfoList = async (outboundNo, outboundType) => {
  let ret
  let checkQuery = {
    outboundNo: outboundNo,
    outboundType: outboundType
  }
  await soapPost(bizTypeMap.queryPrintInfoList, checkQuery)
    .done(function (data) {
      if (_.isEmpty(data)) {
        $notify.error(i18n.t('obShipmentMainNull'))
      }
      ret = data
    })
  return ret
}

// 获取交接单EIRNo
export const queryEIRNo = async (outboundNo, outboundType) => {
  let ret
  let checkQuery = {
    outboundNo: outboundNo,
    outboundType: outboundType
  }
  await soapPost(bizTypeMap.queryEIRNo, checkQuery, { noParseJson: true })
    .done(function (data) {
      if (_.isEmpty(data)) {
        $notify.error(i18n.t('getEIRNoNull'))
      }
      ret = data
    })
  return ret
}

export const querySupplierDetails = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.querySupplierDetails, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const printAbnormalOrderDetails = async (query) => {
  let ret
  await soapPost(bizTypeMap.printAbnormalOrderDetails, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const saveShipmentByObBound = async (checkM, checkRs) => {
  let ret
  let checkMP = {}
  checkM.userName = userInfo.userCode
  checkMP.checkM = checkM
  checkMP.listCheckR = checkRs
  await soapPost(bizTypeMap.handover_202, checkMP)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const scrappedSupplierOutbound = async (checkM) => {
  let ret
  let checkQuery = {}
  checkQuery.outboundNo = checkM.outboundNo
  checkQuery.outboundType = checkM.outboundType
  checkQuery.updateUser = userInfo.userCode
  checkQuery.userName = userInfo.userName
  await soapPost(bizTypeMap.handover_203, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSysConfigValue = async (conditionKey) => {
  let ret
  let dto = {}
  dto.key = conditionKey
  await soapPost(bizTypeMap.master_013, dto)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const querySystemConfigList = async (systemConfigQuery) => {
  let ret
  await soapPost(bizTypeMap.querySystemConfigList, systemConfigQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getDicDetailByCatalog = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_008, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const occupyContainerNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_018, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const closeContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_201, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const closeB2BContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_206, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

// 出库-复核-关闭容器
export const taskContainerClose = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.taskContainerClose, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

// 出库-复核-差异确认
export const taskOrderDiffConfirm = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.taskOrderDiffConfirm, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 出库-复核-删除复核数据
export const removeCheckData = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.removeCheckData, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const releaseContainerBind = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.common_006, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getCheckMRForPackaged = async (newcrete) => {
  let ret
  let config ={
    // eslint-disable-next-line standard/array-bracket-even-spacing
    formatData:[newcrete.outboundNo || newcrete.caseOrOrderNo ]
  }
  await soapPost(bizTypeMap.customer_102, newcrete, config)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getOrdersByOutboundNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_106, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
//add by gongbinglai 2019.03.12  start 非客单复核

export const queryNonCustomerOrdersByContainer = async (obCheckQuery) => {
  let ret;
  await soapPost(bizTypeMap.queryNonCustomerOrdersByContainer, obCheckQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const getCheckPalletByPalletNo = async (obCheckQuery) => {
  let ret;
  await soapPost(bizTypeMap.getCheckPalletByPalletNo, obCheckQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const getUnFullBoardPalletByOUtboundNo = async (obCheckQuery) => {
  let ret;
  await soapPost(bizTypeMap.getUnFullBoardPalletByOUtboundNo, obCheckQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const getCheckBoxByNo = async (obCheckQuery) => {
  let ret;
  await soapPost(bizTypeMap.getCheckBoxByNo, obCheckQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const getSequenceNoForBoxNo = async(obCheckQuery) => {
  let ret;
  let config ={
    noParseJson:true
  }
  await soapPost(bizTypeMap.getSequenceNoForBoxNo, obCheckQuery, config)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const addCheckBox = async(obCheckQuery) => {
  let ret;
  await soapPost(bizTypeMap.addCheckBox, obCheckQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

export const getOrgWarehouseName = async (commonDTO) => {
  const warehoseCode = userInfo.warehouseNo
  const cacheKey = 'orgWarehouseName_' + warehoseCode;
  const cachedData = localStorage.getItem(cacheKey);
  const now = new Date().getTime();

  if (cachedData) {
    const { data, expiry } = JSON.parse(cachedData);
    if (now < expiry) {
      return data; // Cache is not expired, return the data
    }
  }

  // Cache is expired or not present, fetch new data
  try {
    const response = await soapPost(bizTypeMap.getOrgWarehouseName, commonDTO);
    const ret = response;
    const expiry = now + 24 * 60 * 60 * 1000; // 1 day in milliseconds
    localStorage.setItem(cacheKey, JSON.stringify({ data: ret, expiry }));
    return ret;
  } catch (error) {
    // Handle error (e.g., network error, parsing error)
    console.error('Error fetching data:', error);
    throw error;
  }
};
// GOODS_CODE(1, "商品编码"),
//     GOODS_BARCODE(2, "商品条码"),
//     GOODS_SERIAL(3, "商品序列号"),
//     BOX_RULE_CODE(11, "箱规编码"),
//     BOX_RULE_BARCODE(12, "箱规条码"),
//     LPN_CODE(21, "LPN编码"),
// 扫描商品编码、商品barcode、商品序列号, 箱规编码、箱规条码或者LPN，查询对应的商品数据, 箱规数据 或者 LPN数据
// 这里是直接调用的主数据接口，并没有从出库走透传逻辑
export const scanByCode = async (strScanCode, goodsNoList, lpnGoodsNoList = [], options) => {
  let goodsList =[]
  let scanType
  let codeType
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    code:strScanCode,
    needExtAttr: 1,
    colNames: MasterPropertyType.getAllProperty
  }
  if(options && options.isDevice) query.specialType = '1'
  await soapPost(bizTypeMap.scanByCode, query)
    .done(function (data) {
      if(!data){
        return null;
      }else {
          scanType = data.scanType
          codeType = data.codeType
          goodsList = data ? data.list.map(goods => ({
          ...goods,
          codeType : data.codeType,
          scanType : data.scanType,
          serialFlag : goods.serialManageFlag,
          uniqueCodeFlag : goods.uniqueCodeFlag,
          boxType : goods.boxType === 1 ? 3 : goods.boxType, // 这里1表示以箱条码查找的 转为3在复核处理
          boxSpecificationCode : goods.boxRuleCode, // lpn码 或 箱规码
          boxSpecification : goods.baseUnitNum,
          unCode: goods.propertyMap ? goods.propertyMap.dangerousUNCode : undefined,
          breakable: goods.propertyMap ? goods.propertyMap.breakable : undefined,
          batteryNetWeight: goods.propertyMap ? goods.propertyMap.batteryNetWeight : undefined,
          withReadyToShipPackage: goods.propertyMap ? goods.propertyMap.withReadyToShipPackage : undefined,
          batteryCapacity: goods.propertyMap ? goods.propertyMap.batteryCapacity : undefined,
          capacityUnit: goods.propertyMap ? goods.propertyMap.batteryCapacityUnit : undefined,
          exemptFlag: goods.propertyMap ? goods.propertyMap.exemptFlag : undefined,
          adrScore: goods.propertyMap ? goods.propertyMap.adrScore : undefined,
          boxBarcodeList: goods.boxBarcodeList
        })) : []
      }
    })
  // 匹配当前订单内的商品
  goodsList = goodsList.filter(item => [...goodsNoList, ...lpnGoodsNoList].includes(item.goodsNo));
  // 扫描的为箱规码或箱条码 则校验其是否有采集物流属性
  if (scanType === 1 && (codeType === 11 || codeType === 12)) {
    let emptyLogisticsGoodsList = goodsList.find(x => x.boxLength == null || x.boxLength === 0 || x.boxWidth == null || x.boxWidth === 0 || x.boxHeight == null || x.boxHeight === 0 || x.boxWeight == null || x.boxWeight === 0)
    if (!_.isEmpty(emptyLogisticsGoodsList)) {
      $notify.error(i18n.t('logisticsAttributesIsNull'))
    }
  }
  // 唯一码集成码  是普通集成码且是唯一码商品 就定义为唯一码集成码。
  let isUniqeJCM = scanType === 3 && (goodsList.find(x => x.serialType === 3) && goodsList.find(x => x.serialType === 3).uniqueCodeFlag == 1)
  // 唯一码集成码返回子类本身集成码
  if (isUniqeJCM) {
    return goodsList.filter(x=> x.serialType === 3);
  }
  //单个在集成码下的唯一码
  if(scanType === 0 && codeType === 4 && goodsList.length === 1){
    return goodsList;
  }
  //普通集成码返回父类本身集成码
  if (scanType === 3) {
    return goodsList.find(x => x.serialType === 2)
  }
  const isLPN = goodsList.length === 1 && goodsList[0].boxType === 2
  store.commit('SET_SCAN_CONTENT', strScanCode)
  return findGoodsInfo(goodsList, isLPN ? lpnGoodsNoList : goodsNoList)
}

export const scanByCodeForIMEI = async (strScanCode) => {
  let ret = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    needExtAttr: 1,
    code:strScanCode
  }
  await soapPost(bizTypeMap.scanByCode, query)
    .done(function (data) {
      ret = data
    })

  return ret;
}

// 商品条码
export const getGoodsInfoByCodeFour = async (strScanCode, goodsNoList, options, callback) => {
  let goodsList = null;
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
    goodsNo:strScanCode,
    scanCode:strScanCode,
    code:strScanCode,
    needExtAttr: 1,
    colNames: MasterPropertyType.getAllProperty
  }
  if(options && options.isDevice) query.specialType = '1'
  await soapPost(bizTypeMap.getGoodsInfoByCodeFour, query)
    .done(function (data) {
      goodsList = data;
    })
  let baseInfoOfGoods = findGoodsInfo(goodsList, goodsNoList, callback);
  return baseInfoOfGoods;
}

// LPN
export const queryBoxRuleGroupListByCode = async (lpnCode) => {
  let goodsList = null;
  let query = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    boxRuleCodeList: [lpnCode]
  }
  await soapPost(bizTypeMap.wms_masterservice_queryBoxRuleGroupListByCode, query)
    .done(function (data) {
      goodsList = data;
    })
  const baseInfoOfGood = goodsList.length ? goodsList.find(good => good.boxRuleCode === lpnCode) : null
  !baseInfoOfGood && customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('goodsNotInOrderErr'))
  return baseInfoOfGood
}

// 一码多品检查提示
export const findGoodsInfo = async function(listGoods, listGoodsNo, callback) {
  let baseGoods = null;
  if (!_.isEmpty(listGoods)) {
    if (listGoods.length > 1) {
      // 一码多品，如果集合单中的商品包含一码多品的商品有多个就弹出选择框
      let count = 0;
      let strGoodsNo = "";

      // 计算集合单内的商品对应一码多品编码的数量
      for (let gd of listGoods) {
        for (let strNo of listGoodsNo) {
          if (gd.goodsNo == strNo) {
            count++;
            strGoodsNo = strNo;
            break;
          }
        }
      }

      if (count > 1) {
        // 如果有多个对应，弹出选择框，暂时不用弹窗，通过错误拦截
        // $notify.error(i18n.t('multiProduct'))
        // 非su复核页面逻辑
        if (route.history.current.name !== 'suPackNew') {
          callback && callback('multiProduct')
          customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('multiProduct'))
          return;
        }
        // 显示商品选择弹框
        const matchedGoods = listGoods.filter(gd =>
          listGoodsNo.includes(gd.goodsNo)
        );
        // 设置store状态
        store.commit('SET_GOODS_SELECTOR_VISIBLE', true);
        store.commit('SET_GOODS_LIST', matchedGoods);

        // 返回Promise等待用户选择
        return new Promise((resolve, reject) => {
          const unwatch = store.watch(
            (state) => state.newPack.selectedGoods,
            (selectedGoods) => {
              console.log("🚀 ~ returnnewPromise ~ selectedGoods:", selectedGoods)
              if (selectedGoods === null || (Array.isArray(selectedGoods) && selectedGoods.length === 0)) {
                // 用户取消选择
                unwatch();
                store.commit('RESET_GOODS_SELECTOR');
                reject(new Error('用户取消选择'));
              } else if (selectedGoods && selectedGoods.length > 0) {
                // 用户选择了商品
                unwatch();
                store.commit('RESET_GOODS_SELECTOR');
                resolve(selectedGoods[0]); // 返回用户选择的第一个商品
              }
            },
            { deep: true }
          );
        });
      } else {
        listGoods.forEach(function (item) {
          if(item.goodsNo == strGoodsNo){
            baseGoods = item;
            return;
          }
        });
      }
    } else {
      //条码对应的是单个商品
      baseGoods = listGoods[0];
      for (let strNo of listGoodsNo) {
        if(baseGoods.goodsNo == strNo){
          return baseGoods
        }
      }
      //  $notify.error(i18n.t('goodsNotInOrderErr'))
      callback && callback('goodsNotInOrderErr')
      customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('goodsNotInOrderErr'))
      return;
    }
  }
  return baseGoods;
}

//非客单复核添加复核结果
export const addCheckResultForNonCustomer = async (obCheckCR) => {
  let ret;
  let config ={
    noParseJson:true
  }
  await soapPost(bizTypeMap.addCheckResultForNonCustomer, obCheckCR,config)
    .done(function (data) {
      ret = data;
    })
  return ret;
}


export const getCheckRListByTaskNo = async (checkQuery) => {
  let ret;
  await soapPost(bizTypeMap.getCheckRListByTaskNo, checkQuery)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

//非客单满箱操作
export const fullBoxForOrderTask = async (checkQuery) => {
  let ret;
  await soapPost(bizTypeMap.fullBoxForOrderTask, checkQuery,{ noParseJson: true })
    .done(function (data) {
      ret = data;
    })
  return ret;
}

//获取栈板信息
export const getCheckPalletByNo = async (checkPallet) => {
  let ret;
  checkPallet.orgNo = userInfo.orgNo;
  checkPallet.distributeNo = userInfo.distributeNo;
  checkPallet.warehouseNo = userInfo.warehouseNo;

  let config = {}
  config.noParseJson=false
  await soapPost(bizTypeMap.getCheckPalletByNo, checkPallet,config)
    .done(function (data) {
      ret = data;
    });
  return ret;
}
//操作满板
export const processFullBoard = async (checkPallet) => {
  let ret;
  checkPallet.updateUser = userInfo.userCode;//修改人
  checkPallet.userName = userInfo.userName;
  checkPallet.orgNo = userInfo.orgNo;
  checkPallet.distributeNo = userInfo.distributeNo;
  checkPallet.warehouseNo = userInfo.warehouseNo;

  let config = {}
  config.noParseJson = true
  await soapPost(bizTypeMap.processFullBoard, checkPallet,config)
    .done(function (data) {
      ret = data;
    })
  return ret;
}

//删除已复核结果
export const delCheckRForOrderTask = async (deleteCheckR) => {
  let ret;
  let config = {}
  config.noParseJson=true
  await soapPost(bizTypeMap.delCheckRForOrderTask, deleteCheckR,config)
    .done(function (data) {
      ret = data;
    })
  return ret;
}
//关闭容器
export const closeContainerForOrderTask = async (checkME) => {
  let ret;
  let config = {}
  config.noParseJson=true
  await soapPost(bizTypeMap.closeContainerForOrderTask, checkME,config)
    .done(function (data) {
      ret = data;
    })
  return ret;
}



//add by gongbinglai 2019.03.12  end 非客单复核

export const getShipmentNoList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wave_001, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

export const getCodeNameAndImageBytes = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.common_023, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

export const addOrderPackage = async (newcrete) => {
  let ret
  console.log('addOrderPackage-202')
  await soapPost(bizTypeMap.customer_202, newcrete, { noParseJson: true })
  .done(function (data) {
    ret = data
  })
  return ret
}

export const getOrderInvoiceInfoGlobalization = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wave_011, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

export const getOrderPackageTagInfoID = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wave_012, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

export const qryPackageTagHideInfo = async (newcrete) => {
  let ret
  try {
    await soapPost(bizTypeMap.master_025, newcrete)
    .done(function (data) {
      ret = data
    })
  } catch (ex) {
    console.log("qryPackageTagHideInfo error:" + ex.message)
  }
  return ret
}

/**
 * 获取面单信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const getFaceInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getFaceInfo, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 获取3PL面单
 * @param param
 * @returns {Promise.<*>}
 */
export const get3PLFace = async (param) => {
  let ret
  await soapPost(bizTypeMap.getLabels, param)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const get3PLFaceNew = async (param) => {
  let ret
  await soapPost(bizTypeMap.getLabelsForJDW, param)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const batchGetLabelsForJDW = async (param) => {
  let ret
  await soapPost(bizTypeMap.batchGetLabelsForJDW, param)
    .done(function (data) {
      ret = data
    })
  return ret
}
/**
 * 获取3PL异步面单(返回报文和3pl下单接口返回报文一样)
 */
export const get3plAsyncLabel = async (param) => {
  return post(restUrls.url_3pl_async_label, param, true)
}
/**
 * 打单平台获取发票、箱单和退货单
 * @param param
 * @returns {Promise.<*>}
 */
 export const getPrintPlatform = async (param) => {
  let ret
  console.log('打印加固6 入参', param);
  await soapPost(bizTypeMap.printPlatformPrint, param)
  .done(function (data) {
    ret = data
  })
  console.log('打印加固6 回参', ret);
  return ret
}
// 3pl打单老打印接口
export const getPrint3PLPlatformPrintCenter = async (param) => {
  let ret
  console.log('打印加固3 入参', param);
  await soapPost(bizTypeMap.globalPrint, param)
  .done(function (data) {
    ret = data
  })
  console.log('打印加固3 回参', ret);
  return ret
}
/**
 * 打印中心获取manifest包裹信息
 * @param param
 * @returns {Promise.<*>}
 */
export const getDangerousPrintPlatform = async (param) => {
  let ret
  console.log('打印加固4 入参', param);
  await soapPost(bizTypeMap.printDangerousLabel, param)
  .done(function (data) {
    ret = data
  })
  console.log('打印加固4 回参', ret);
  return ret
}

// PO标签打印
export const getAddressByTrackingNumber = async (param) => {
  let ret
  console.log('打印加固5 入参', param);
  await soapPost(bizTypeMap.getAddressByTrackingNumber, param)
  .done(function (data) {
    ret = data
  })
  console.log('打印加固5 回参', ret);
  return ret
}



/**
 * 打单平台获取发票、箱单和退货单【批量】
 * @param param
 * @returns {Promise.<*>}
 */
export const getBatchPrintPlatform = async (param) => {
  return post(restUrls.url_batchPrintPlatform, param, true)
}
/**
 * 保存3PL包裹信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const savePackageTagFor3PL = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_215, newcrete, { noParseJson: true })
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 单包裹保存运单号
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const setPackageTrackingNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.setPackageTrackingNo, newcrete, { noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

/**
 * 根据包裹号获取包裹信息（重打包裹标签）
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const getPackageMByQueryBean = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_103, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 获取订单主档信息ob_check_m
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const getCheckMByOutboundNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.common_002, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 获取订单主档信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
 export const getOrderByOutboundNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.getOrderByOutboundNo, param)
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 根据包裹号获取包裹信息（重打包裹标签）
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const exportExcelPreCheck = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.exportExcelPreCheck, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const queryDistributionList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryDistributionList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

/**
 * 添加重新打印包裹标签
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const addRePrintPackageLabel = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.customer_205, newcrete, { noParseJson: true })
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 从初始化获取订单附属性信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const giveReminderForPackage = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wave_008, newcrete)
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 通过Upc获取耗材信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const getConsumbleByUpc = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.master_026, newcrete, { noParseJson: false })
  .done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 获取耗材信息
 * @param newcrete
 * @returns {Promise.<*>}
 */
export const scanConsumableByOwnerFallback = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.scanConsumableByOwnerFallback, newcrete, { noParseJson: false })
  .done(function (data) {
    ret = data
  })
  return ret
}

// 通过包裹号/订单号查询包裹信息
export const queryPackageInfoByscanCode = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPackageInfoByscanCode, checkQuery)
  .done(function (data) {
    ret = data
  })
  return ret
}

// 通过包裹号/订单号查询包裹信息
export const queryPackageInfoByscanCodeOCReplace = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPackageInfoByscanCodeOCReplace, checkQuery)
  .done(function (data) {
    ret = data
  })
  return ret
}

// 保存包裹换单记录
export const savePackageReplacePrintLog = async (packageLog) => {
  let ret
  await soapPost(bizTypeMap.savePackageReplacePrintLog, packageLog)
  .done(function (data) {
    ret = data
  })
  return ret
}
//wnagzhi 2021-4-12  begin
//根据订单号查询可拦截发货订单信息
export const querySMInterceptOrderLists = async (parameters) => {
  console.info("parameters:"+ parameters);
  let ret
  await soapPost(bizTypeMap.querySMInterceptOrderLists, parameters)
    .done(function (data) {
      console.log("data" + data)
      ret = data
    })
  return ret
}
//拦截生成退客单，生成上架任务，更新原来栈板号，类型：拦截上架
export const sendGoodsInterceptAfter = async (newcrete) => {
  console.info("parameters:"+ newcrete);
  let ret
  await soapPost(bizTypeMap.sendGoodsInterceptAfter,newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
//b2b发货拦截将零散订单添加到新的空闲栈板中，满板
export const addCheckPalletInfo = async (newcrete) => {
  console.info("parameters:"+ newcrete);
  let ret
  await soapPost(bizTypeMap.addCheckPalletInfo,newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
//end

// 获取发票信息列表
export const queryObExpandList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryObExpandList, checkQuery)
  .done(function (data) {
    ret = data
  })
  return ret
}
// 获取发票货主
export const queryObExpandOwners = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryObExpandOwners, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 门店打包-获取扫描包裹的信息 如果不属于当前正在扫描的门店或者重复扫描都失败
export const checkPackage = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.checkPackage, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 门店打包-获取需要门店打包的包裹数量
export const getNeedStorePackageNum = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getNeedStorePackageNum, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 门店打包-根据类型获取包裹信息
export const queryPackagesInfoWithType = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPackagesInfoWithType, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 门店打包-满包裹操作数据校验
export const checkWhetherThePackageEachOrderIsAllIn = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.checkWhetherThePackageEachOrderIsAllIn, checkQuery,{noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}
// 门店打包-满包裹操作
export const submitStorePackages = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.submitStorePackages, checkQuery,{noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}
// 门店打包-更新包裹主表运单号
export const updateShipNos = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.updateShipNos, checkQuery,{noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

// 门店打包-获取复核结果
export const getCheckRByOutboundNo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getCheckRByOutboundNo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取订单详情
export const queryShipmentMExpandAttr = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryShipmentMExpandAttr, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取待复核数据和已复核明细
export const getCheckDataByTaskPageNoAndOrderNo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getCheckDataByTaskPageNoAndOrderNo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 按商品提交复核
export const submitCheckData = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.submitCheckData, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 按商品提交复核
export const fullPackage = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.fullPackage, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询 订单基础数据
export const getObShipmentAllData = async (ObShipmentQuery) => {
  let ret
  await soapPost(bizTypeMap.getObShipmentAllData, ObShipmentQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取托盘码信息
export const getQueryPalletInfoByPrint = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getQueryPalletInfoByPrint, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取vas信息
export const queryVasDetailListInfo = async (checkQuery) => {
  console.log("🚀 ~ queryVasDetailListInfo ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.queryVasDetailListInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 子不语临时箱唛补打
export const queryZBYTempBoxLabelForPrint = async (checkQuery) => {
  console.log("🚀 ~ queryZBYTempBoxLabelForPrint ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.queryZBYTempBoxLabelForPrint, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 获取已完成独立打包订单详情
export const queryRepackagePrintInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryRepackagePrintInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取已完成独立打包订单详情(门店包裹)
export const queryRepackageBoxListInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryRepackageBoxListInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取已完成独立打包订单正向面单详情(门店包裹)
export const queryForwardLabelInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryForwardLabelInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 根据订单号，包裹号，取已完成独立打包的订单包裹号标签
export const queryPackageCodeLabelInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPackageCodeLabelInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
//根据出库单号查询面单信息
export const queryWaybillOrderInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryWaybillOrderInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
//根据出库单号查询送货单信息
export const queryDeliveryOrderInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryDeliveryOrderInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
//根据出库单号查询送货单信息【批量】
export const batchQueryDeliveryOrderInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.batchQueryDeliveryOrderInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

//根据出库单号查询出库单打印信息
export const queryOutboundOrderInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryOutboundOrderInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据批次号查询交接信息
export const getHandoverMsgByBatchNo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getHandoverMsgByBatchNo, checkQuery, { noShowError: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据批次号查询发票集信息
export const getPackageMDByBatchNo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.wms_parcelHandover_getGoodsOutBoundNumByBatchNo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

//海康 获取订单下的所有包裹
export const getHikPackingList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getHikPackingList, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

//海康 查询pod单信息
export const getHikPodInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getHikPodInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
//海康 查询包裹信息
export const getHikPackagePackingList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getHikPackagePackingList, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
//海康 查询包裹信息(补打)
export const getHikPackagePackingListAfterCheck = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getHikPackagePackingListAfterCheck, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 蔚来 查询包裹信息
export const getNioPackingList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getNioPackingList, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询某个业务总共配置了哪些能力，比如复核/打单
export const getAbilities = async (query) => {
  // 定义一个键名，用于localStorage中存储数据
  const storageKey = `abilities_${JSON.stringify(query)}`;
  const storedData = localStorage.getItem(storageKey);

  // 检查localStorage中是否有数据以及数据是否过期
  if (storedData) {
    const { data, expiry } = JSON.parse(storedData);
    if (expiry > Date.now()) {
      // 如果数据未过期，直接返回存储的数据
      return data;
    }
  }

  // 如果localStorage中没有数据或数据已过期，则调用接口获取数据
  let ret;
  await soapPost(bizTypeMap.getAbilities, query)
    .done(function (data) {
      ret = data;
      // 将获取到的数据存储到localStorage中，同时设置过期时间为1天后
      const expiry = Date.now() + (60 * 60 * 1000); // 1小时的毫秒数
      localStorage.setItem(storageKey, JSON.stringify({ data: ret, expiry }));
    });
  return ret;
}
export const queryAbilityList = async (query) => {
  let ret
  await soapPost(bizTypeMap.queryAbilityList, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 校验某个货主或者商家是否具备某项能力
export const checkAbility = async (query) => {
  let ret
  await soapPost(bizTypeMap.checkAbility, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据订单号和组织机构信息获取订单的基础信息（shipment_m和expand）
export const queryPrintOrderLists = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPrintOrderLists, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据订单号和组织机构信息修改订单的基础信息（shipment_m和expand）
export const modifyPrintOrderData = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.modifyPrintOrderData, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 3pl新接口
export const call3plPlatformNew = async (printParam) => {
  let ret
  console.log('打印加固call3plPlatformNew', printParam);
  await soapPost(bizTypeMap.printDocAll, printParam)
    .done(function (data) {
      ret = data
    })
  console.log('打印加固call3plPlatformNew return', ret);
  return ret
}

// 补打面单-通用箱单 Packinglist
export const queryCommonPackageDetail = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryCommonPackageDetail, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据订单号、包裹号获取已完成打包订单和复核结果详情
export const queryRepackagePrintInvoiceInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryRepackagePrintInvoiceInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 根据订单号、包裹号获取已完成打包订单和复核结果详情
export const queryPrePrintOrderInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryPrePrintOrderInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 根据订单号、包裹号获取已完成打包订单和复核结果详情
export const getPalletPrintSsccParam = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.getPalletPrintSsccParam, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 根据订单号查询订单信息
export const queryOrderInfoByOutboundNos = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryOrderInfoByOutboundNos, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 获取一键退供 列表
export const getOrdersInfoByOutboundNo = async (queryDoc) => {
  let ret = null
  await soapPost(bizTypeMap.getOrdersInfoByOutboundNo, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取一键退供 列表
export const addCheckResultForManualLocate = async (queryDoc) => {
  let ret = null
  await soapPost(bizTypeMap.addCheckResultForManualLocate, queryDoc, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}


// 根据订单号列表获取已完成打包订单和复核结果详情列表
export const queryRepackagePrintList = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryRepackagePrintList, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据订单号、包裹号获取已完成打包订单和复核结果详情
export const queryShelfLifeGoodsInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryShelfLifeGoodsInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据SKU,批属性值获取SKU批次信息
export const getSkuLotInfoByLotAttrValue = async (params) => {
  let ret
  await soapPost(bizTypeMap.getSkuLotInfoByLotAttrValue, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据SKU,批属性值校验包装批号是否合规
export const checkPackageBatchNumber = async (params) => {
  let ret
  await soapPost(bizTypeMap.checkPackageBatchNumber, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据SKU,批属性值校验包装批号是否合规
export const getOrderInfoByOutboundNo = async (params) => {
  let ret
  await soapPost(bizTypeMap.getOrderInfoByOutboundNo, params)
    .done(function (data) {
      ret = data
    })
  return ret
}
//推荐耗材信息查询
export const queryRecommendConsumables = async (parameters) => {
  let ret = null
  let query = {
    orgNo:userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo,
  }
  await soapPost(bizTypeMap.wms_queryRecommendConsumables, {...query,...parameters},{noShowError:true})
  .done(function (data) {
    ret = data;
  })
  return ret
}
// 分选复核门店打包一体化-获取包裹的信息
export const checkOutboundNos = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.checkOutboundNos, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 分选复核门店打包一体化-获取包裹的信息
export const queryStorePackageInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryStorePackageInfo, checkQuery)
  .done(function (data) {
    ret = data
  })
return ret
}

export const queryStorePackageRepackInfo = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.queryStorePackageRepackInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 根据集合单号下载爆品复核拼单PDF文件
export const getPackagePDFByBatchNo = async (params) => {
  let ret
  await soapPost(bizTypeMap.getPackagePDFByBatchNo, params)
    .done(function (data) {
      ret = data
    })
  return ret
}
//查询商品大类
export const queryCatalogListByGoodsNo = async (params) => {
  let ret
  await soapPost(bizTypeMap.queryCatalogListByGoodsNo, params,{noShowError:true})
    .done(function (data) {
      ret = data
    })
  return ret
}

// 补打面单-通用箱单 Packinglist
export const queryPackageDByOutboundNo = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.getPackageDByOutboundNo, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询包裹列表
export const queryPackageMByOutboundNo = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryPackageMByOutboundNo, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 复核-查询3pl规则
export const queryUnScoreRule = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryUnScoreRule, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
//Trafilea打印逆向面单
export const queryShipmentLabel = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryShipmentLabel, parameters)
    .done(function (data) {
      ret = data
    })
    return ret
  }
//随货文件
export const queryFollowGoodsFiles = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryFollowGoodsFiles, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
 //托规格采集
export const palletConfiguration = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.collectPalletSpecifications, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 绑定栈板
export const bindPalletForNonCustomerOrder = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.bindPalletForNonCustomerOrder, parameters)
  .done(function (data) {
    ret = data
  })
return ret
}
// 获取sscc前置打印参数
export const getPreprintSsccParam = async (params) => {
  let ret
  await soapPost(bizTypeMap.getPreprintSsccParam, params)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 获取石头科技sscc标签参数
export const getPrintSkuSsccParam = async (params) => {
  let ret
  await soapPost(bizTypeMap.getPrintSkuSsccParam, params)
    .done(function (data) {
      ret = data
    })
  return ret
}
 //托盘号生成
 export const generateBillNumber = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.generateBillNumber, parameters,{ noParseJson: true })
    .done(function (data) {
      ret = data;
       })
  return ret
}

// 新增业务数据导入
export const insertWmsbusinessVolume = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.insertWmsbusinessVolume, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

 //满托接口
 export const addPalletInfo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.addPalletInfo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

 //新满托接口
 export const addPalletInfoNew = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.addPalletInfoNew, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 修改业务数据导入
export const updateWmsbusinessVolume = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.updateWmsbusinessVolume, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 删除业务数据导入
export const deleteWmsBusinessVolumeList = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.deleteWmsBusinessVolumeList, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询业务数据导入
export const queryWmsBusinessVolumeList = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryWmsBusinessVolumeList, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 批量删除
export const batchDeleteBusinessVolume = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.batchDeleteBusinessVolume, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
//根据集合单号获取订单号
export const getOrderNoByBatchNo  = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.getOrderNoByBatchNo , parameters)
  .done(function (data) {
    ret = data;
  })
return ret
}
//满包裹 包裹规则校验
export const validatePackagingRules = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.validatePackagingRules, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//订单号集合 去3pl拿sscc
export const getPrint3PLPlatformByOrder = async (param) => {
  return post(restUrls.gtc_print, param, true)
}

// 云打印自绘模板版本管理-新增
export const insertItemBaseStackCloudPrint = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.insertItemBaseStackCloudPrint, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 云打印自绘模板版本管理-修改
export const updateCloudPrintConfig = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.updateCloudPrintConfig, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 云打印自绘模板版本管理-查询
export const queryCloudPrintConfigList = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.queryCloudPrintConfigList, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 云打印自绘模板版本管理-删除
export const deleteCloudPrintConfig = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.deleteCloudPrintConfig, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}

 // 查询可以重新call单的包裹信息
export const getRecallPackageList = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.getRecallPackageList, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询调度查询状态
export const queryDispatchInquiryStatus = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.queryDispatchInquiryStatus, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 组装call单参数
export const recallFaceSheet = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.recallFaceSheet, parameters)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 上传bol文件接口
export const insertShipmentLabel = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.insertShipmentLabel, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

// call单成功回调
export const callSuccessCallBack = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.callSuccessCallBack, parameters)
    .done(function (data) {
      ret = data
    })
    return ret
}
// 批量获取商品信息
export const getGoodsByGoodsNos = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.getGoodsByGoodsNos, parameters)
    .done(function (data) {
      ret = data;
  })
  return ret
}

export const saveCheckSerialData = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.saveCheckSerialData, newcrete, { noParseJson: true, noShowError: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const batchSaveCheckSerialData = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.batchSaveCheckSerialData, newcrete, { noParseJson: true, noShowError: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const removeCheckSerialData = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.removeCheckSerialData, newcrete, { noParseJson: true, noShowError: true })
    .done(function (data) {
      ret = data
    })
  return ret
}
// 删除bol文件接口
export const deleteShipmentLabel = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.deleteShipmentLabel, query)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const getPalletPackage = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPalletPackage, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const recordObWaybillPrint = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.recordObWaybillPrint, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const addCheckResultForExplosive = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.addCheckResultForExplosive, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const printExplosiveList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.printExplosiveList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const bindShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.bindShippingContainer, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const fullAndBindShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.fullAndBindShippingContainer, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const fullShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.fullShippingContainer, newcrete, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

export const scanShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.scanShippingContainer, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const queryHandoverPackageInShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryHandoverPackageInShippingContainer, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const batchHandoverPackageInShippingContainer = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.batchHandoverPackageInShippingContainer, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const getLatestBillNum = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getLatestBillNum, newcrete, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}
export const updateLatestBillNum = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.updateLatestBillNum, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const getOrderInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getOrderInfo, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const updateTmpOutbound = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.updateTmpOutbound, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
/**
 * 获取库存积压分析
 */
export const queryStockBacklog = async (param) => {
  return post(restUrls.stockBacklog_url, param, true)
}

/**
 * imp 操作日志记录
 */
export const impSubmitLog = async (param) => {
  return post(restUrls.submitLog_url, param, true)
}

export const getPackOperationDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPackOperationDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackTaskList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPackTaskList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackExceptionList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPackExceptionList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPackTaskDetails = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPackTaskDetails, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getRebinTaskList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getRebinTaskList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getRebinSubpageDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getRebinSubpageDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const getRebinTaskDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getRebinTaskDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const exportTableDataCommon = async (service, newcrete) => {
  let ret
  await soapPost(bizTypeMap[service], newcrete, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

export const exportSuListCommon = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.exportSuListCommon, newcrete, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getRebinExcepion = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getRebinExcepion, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

/**
 * 首页-小时看板
 */
export const queryProgressBoard = async (param) => {
  return post(restUrls.progressBoard_url, param, true)
}

export const getPickingTaskList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPickingTaskList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPickingSubpageDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPickingSubpageDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}


export const getPickingTaskDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPickingTaskDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getPickingExcepion = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPickingExcepion, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const batchGetWayBilNumber = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.batchGetWayBilNumber, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSortingTaskList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getSortingTaskList, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSortingTaskDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getSortingTaskDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSortingSubpageDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getSortingSubpageDetail, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const getSortingExcepion = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getSortingExcepion, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const queryBigPackagePrintLabelByBatchNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryBigPackagePrintLabelByBatchNo, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}

export const queryTCLPalletInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryTCLPalletInfo, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const printHandoverInfoOfServiceBillCode = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.printHandoverInfoOfServiceBillCode, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const printProofOfDeliveryOfServiceBillCode = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.printProofOfDeliveryOfServiceBillCode, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryFnSkuInfoByQty = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryFnSkuInfoByQty, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryFnSkuInfoForPrint = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryFnSkuInfoForPrint, newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryFBADeliveryNoteByBatchNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryFBADeliveryNoteByBatchNo, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}
export const rePrintGoodsLabel = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.rePrintGoodsLabel, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}
export const reprintAdr = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.reprintAdr, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}
export const queryLabelsOfOutboundNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryLabelsOfOutboundNo, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}

// 子不语重置包裹
export const deletePackageByPackageNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.deletePackageByPackageNo, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
  return ret
}
// 获取沙特起网打印参数
export const getLabelsForSelfCloudPrint = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getLabelsForSelfCloudPrint, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
    return ret
}

// 获取adr打印参数
export const getPrintAdrFileInfo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.getPrintAdrFileInfo, newcrete)
    .done(function (data) {
      ret = data
      console.log("🚀 ~ ret:", ret)
    })
    return ret
}

// 小鹏-订单维度packingList
export const xPengPackingListByOrder = async (checkQuery) => {
  console.log("🚀 ~ xPengPackingListByOrder ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.xPengPackingListByOrder, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 小鹏-托维度packingList
export const xPengPackingListByPallet = async (checkQuery) => {
  console.log("🚀 ~ xPengPackingListByPallet ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.xPengPackingListByPallet, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 小鹏-包裹维度packingList
export const xPengPackingListByPackage = async (checkQuery) => {
  console.log("🚀 ~ xPengPackingListByPackage ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.xPengPackingListByPackage, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 小鹏-DA-订单维度
export const rePrintOrderDAInfo = async (checkQuery) => {
  console.log("🚀 ~ rePrintOrderDAInfo ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.rePrintOrderDAInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 小鹏-CI-订单维度
export const rePrintOrderCIInfo = async (checkQuery) => {
  console.log("🚀 ~ rePrintOrderCIInfo ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.rePrintOrderCIInfo, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 上报打包差异
export const confirmPackageDiffer = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.confirmPackageDiffer, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 校验允许缺量出库订单，是否需要重投
export const singleVerifyCheckDiffGoodsStock = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.singleVerifyCheckDiffGoodsStock, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 汉朔多级序列号防止重复扫描
export const validateHugeSerial = async (checkQuery) => {
  let ret
  await soapPost(bizTypeMap.validateHugeSerial, checkQuery)
  .done(function (data) {
      ret = data
    })
  return ret
}

// 大订单后端缓存接口
export const saveCheckCacheData = async (data) => {
  let ret
  await soapPost(bizTypeMap.saveCheckCacheData, data, {noShowError: true})
  .done(function (data) {
      ret = data
    })
  return ret
}

export const getCheckCacheData = async (data) => {
  let ret
  await soapPost(bizTypeMap.getCheckCacheData, data, {noShowError: true})
  .done(function (data) {
      ret = data
    })
  return ret
}
export const removeCheckCacheData = async (data) => {
  let ret
  await soapPost(bizTypeMap.removeCheckCacheData, data, {noShowError: true})
  .done(function (data) {
      ret = data
    })
  return ret
}


// 按箱换标查询接口
export const replaceSSCCLabel = async (checkQuery) => {
  console.log("🚀 ~ replaceSSCCLabel ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.replaceSSCCLabel, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 按箱换标完成接口
export const updateReplaceSSCCLabelSuccess = async (checkQuery) => {
  console.log("🚀 ~ updateReplaceSSCCLabelSuccess ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.updateReplaceSSCCLabelSuccess, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 托换标查询接口
export const replacePalletSSCCLabel = async (checkQuery) => {
  console.log("🚀 ~ replacePalletSSCCLabel ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.replacePalletSSCCLabel, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 托换标完成接口
export const updateReplacePalletSSCCLabelSuccess = async (checkQuery) => {
  console.log("🚀 ~ updateReplacePalletSSCCLabelSuccess ~ checkQuery:", checkQuery)
  let ret
  await soapPost(bizTypeMap.updateReplacePalletSSCCLabelSuccess, checkQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}